import { FC } from 'react';
import { isEmpty } from 'radash';
import RelatedGrid from '@components/relatedGrid/RelatedGrid';
import { SeeAll } from '@components/seeAll';
import { Title } from '@components/title';
import { ITipCard } from '@shared/models/tipsAndTricks.model';
import { ModuleType } from '@shared/types/module.type';
import { analytics } from '@shared/utils/segment.utils';
import { Container } from './RelatedTips.style';
interface Props {
  data: ITipCard[];
  tipsCategories: number[];
}
const RelatedTips: FC<Props> = ({
  data,
  tipsCategories
}: Props) => {
  const generateUrl = (): string => {
    const baseUrl = `/search?c=${ModuleType.TipsTricks}`;
    const filterMeatsStr = tipsCategories.reduce((acc, prev, index) => {
      return `${acc}${index === 0 ? '' : ','}t_tipsTiricks_${prev}`;
    }, '');
    let output = baseUrl;
    if (!isEmpty(filterMeatsStr)) {
      output = `${baseUrl}&f=${filterMeatsStr}`;
    }
    return output;
  };
  return <Container>
            <RelatedGrid cardType={ModuleType.TipsTricks} title={<Title text="เคล็ดลับที่คุณน่าจะสนใจ" extra={<SeeAll url={generateUrl()} onClick={() => {
      analytics.track('Related Tips Tricks See All Click', {
        event: 'Related Tips Tricks See All Click'
      });
    }} />} />} dataList={data} desktopColumn={3} mobileColumn={1} eventSection="Related Tips Tricks" />
        </Container>;
};
export default RelatedTips;